export default {
  en: {
    supplementCharge: 'Supplement Charge',
    isDefault: 'Default',
    name: 'Name',
    keyword: 'Keyword',
    type: 'Type',
    rate: 'Rate',
    unit: 'Unit',
    periodOfStay: 'Period of Stay',
    conditionDetail: 'Condition Detail',
    newSupplement: 'New Supplement Charge',
    confirmRemoveSupplementTitle: 'Confirm',
    confirmRemoveSupplementMessage: 'Confirm to delete <strong>{supplementChargeName}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeSupplementSuccess: 'Delete supplement charge success',
    allTheTime: 'All',
    UNIT_TYPE: {
      PER_PERSON: '/ Person',
      PER_ROOM: '/ Room',
      PER_BOOKING: '/ Booking',
      DISCOUNT: 'Discount',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: '.-',
      PERCENT: '%',
      NOT_AVAILABLE: 'N/A'
    },
    updateIsDefaultSuccessTitle: 'Success',
    updateIsDefaultSuccessMessage: 'Update Default Success'
  },
  th: {
    supplementCharge: 'รายการเพิ่มเติม',
    isDefault: 'ค่าเริ่มต้น',
    name: 'ชื่อ',
    keyword: 'คำที่ต้องการค้นหา',
    type: 'ประเภท',
    rate: 'ราคา',
    unit: 'หน่วย',
    periodOfStay: 'ช่วงเวลา',
    conditionDetail: 'รายละเอียด',
    newSupplement: 'สร้างรายการเพิ่มเติม',
    confirmRemoveSupplementTitle: 'ยืนยัน',
    confirmRemoveSupplementMessage: 'กรุณายืนยันการลบ <strong>{supplementChargeName}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeSupplementSuccess: 'ลบ supplement charge สำเร็จ',
    allTheTime: 'ตลอดระยะสัญญา',
    UNIT_TYPE: {
      PER_PERSON: '/ คน',
      PER_ROOM: '/ ห้อง',
      PER_BOOKING: '/ บุ๊คกิ้ง',
      DISCOUNT: 'ส่วนลด',
      NOT_AVAILABLE: 'N/A'
    },
    PRICE_TYPE: {
      NET: '.-',
      PERCENT: '%',
      NOT_AVAILABLE: 'N/A'
    },
    updateIsDefaultSuccessTitle: 'สำเร็จ',
    updateIsDefaultSuccessMessage: 'แก้ไขค่าเริ่มต้นสำเร็จ'
  }
}
